/** Lets login flow trigger permission load without circular imports. */
let loadPermissionsFn = null;

export const registerPermissionLoader = (loader) => {
  loadPermissionsFn = typeof loader === "function" ? loader : null;
};

/** @param {{ force?: boolean }} [options] */
export const triggerPermissionLoad = (options) => loadPermissionsFn?.(options);
